// Public child routes override authenticated ancestors. No user-role guessing.
function adminRouteContext(route) {
  const matched = route && route.matched || []
  const record = [...matched].reverse().find(item => item.meta && (typeof item.meta.adminLocalization === 'boolean' || typeof item.meta.requiresAuthentication === 'boolean'))

  if (!record) return null

  return typeof record.meta.adminLocalization === 'boolean' ? record.meta.adminLocalization : record.meta.requiresAuthentication
}
module.exports = { adminRouteContext }
